import { useCallback, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { EmailForwardingSender } from "@/jenesys-types/jenesys-entities/config";

import {
  addSender,
  deleteSender,
  loadSenders,
  updateSender,
  uploadCSV
} from "@/store/features/clientSettings/emailForwardingSenders/emailForwardingSenders";

export const useEmailForwardingSenders = ({
  clientId
}: {
  clientId: string;
}) => {
  const dispatch = useDispatch();
  const {
    senders,
    isLoading,
    error,
    isAddingSender,
    isUpdatingSender,
    isDeletingSender,
    isUploadingCSV
  } = useSelector((state: any) => state.features.emailForwardingSenders);

  useEffect(() => {
    if (clientId) {
      dispatch(loadSenders(clientId));
    }
  }, [dispatch, clientId]);

  const handleAddSender = useCallback(
    (
      data: Omit<EmailForwardingSender, "id" | "date_added">,
      onSuccess?: () => void
    ) => {
      dispatch(addSender(clientId, data, onSuccess));
    },
    [dispatch, clientId]
  );

  const handleUpdateSender = useCallback(
    (
      id: string,
      data: Partial<EmailForwardingSender>,
      onSuccess?: () => void
    ) => {
      dispatch(updateSender(clientId, id, data, onSuccess));
    },
    [dispatch, clientId]
  );

  const handleDeleteSender = useCallback(
    (email: string, onSuccess?: () => void) => {
      dispatch(deleteSender(clientId, email, onSuccess));
    },
    [dispatch, clientId]
  );

  const handleUploadCSV = useCallback(
    (file: File, onSuccess?: () => void) => {
      dispatch(uploadCSV(clientId, file, onSuccess));
    },
    [dispatch, clientId]
  );

  return {
    senders,
    isLoading,
    error,
    isAddingSender,
    isUpdatingSender,
    isDeletingSender,
    isUploadingCSV,
    handleAddSender,
    handleUpdateSender,
    handleDeleteSender,
    handleUploadCSV
  };
};
